


import React, { useState } from 'react';


export default function RestoreSidebarButton({
    onClick,
    position = 'left',
    defaultIcon,
    hoverIcon,
    title = 'Show Sidebar',
}) {


    const [isSideBarExpandButtonHovering, setIsSideBarExpandButtonHovering] = useState(false);

    const positionStyles = {
        top: '20px',
        zIndex: 1000,
        position: 'absolute',
        left: position === 'left' ? '20px' : undefined,
        right: position === 'right' ? '20px' : undefined,
    };


    return (
        <button
            className="restore-sidebar-button"
            onClick={onClick}
            title={title}
            onMouseEnter={() => setIsSideBarExpandButtonHovering(true)}
            onMouseLeave={() => setIsSideBarExpandButtonHovering(false)}
            style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                ...positionStyles,
            }}
        >
            <img
                src={isSideBarExpandButtonHovering ? hoverIcon : defaultIcon}
                alt={title}
                style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    boxShadow: isSideBarExpandButtonHovering
                        ? 'var(--ph-box-shadow-on-map-buttons-hover)'
                        : 'var(--ph-box-shadow-nothover)',
                    transition: 'box-shadow 0.2s ease',
                }}
            />
        </button>
    );
}



